import { Fragment } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import type { LucideIcon } from "lucide-react";

export interface ReponseNonScoreeCopsoq3 {
  name: string;
  rubrique?: string;
  question: string;
  reponse: string | number | string[];
}

function formaterReponse(reponse: ReponseNonScoreeCopsoq3["reponse"]): string {
  return Array.isArray(reponse) ? reponse.join(", ") : String(reponse);
}

/** Réponses non scorées du COPSOQ III (partie 1 « profil », partie 3
 * « questions médicales »), dans l'ordre du questionnaire. */
export function Copsoq3ReponsesNonScorees({
  titre,
  icone: Icone,
  reponses,
}: {
  titre: string;
  icone: LucideIcon;
  reponses: readonly ReponseNonScoreeCopsoq3[];
}) {
  if (reponses.length === 0) return null;

  return (
    <Card className="w-full">
      <CardHeader>
        <div className="flex items-center gap-3">
          <Icone className="h-5 w-5 text-muted-foreground" />
          <CardTitle className="text-base">{titre}</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        <table className="w-full text-sm">
          <tbody>
            {reponses.map((r, i) => (
              <Fragment key={r.name}>
                {r.rubrique && r.rubrique !== reponses[i - 1]?.rubrique && (
                  <tr className="border-t border-border bg-muted/30">
                    <th
                      colSpan={2}
                      className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground"
                    >
                      {r.rubrique}
                    </th>
                  </tr>
                )}
                <tr className="border-t border-border">
                  <td className="px-4 py-2 align-top">{r.question}</td>
                  <td className="px-4 py-2 align-top font-medium w-2/5">
                    {formaterReponse(r.reponse)}
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
